import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { qtyFmt } from "../lib/api";

export function ProductCombobox({ products, value, onChange, depotId, testid = "product-combobox" }) {
  const [open, setOpen] = useState(false);
  const selected = products.find((p) => p.id === value?.id);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-slate-950 px-3 text-left text-sm hover:border-slate-600 transition-colors"
        >
          <span className={selected ? "truncate" : "text-slate-500"}>
            {selected ? `${selected.sku} · ${selected.name}` : "Search product by name or SKU"}
          </span>
          <ChevronsUpDown className="h-4 w-4 text-slate-500 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[280px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Type to search…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No product found. Add it under Products.</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem
                  key={p.id}
                  value={`${p.sku} ${p.name}`}
                  onSelect={() => { onChange(p); setOpen(false); }}
                  data-testid={`${testid}-option-${p.sku}`}
                >
                  <Check className={`h-4 w-4 ${value?.id === p.id ? "opacity-100 text-amber-500" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{p.name}</span>
                  <span className="font-mono text-xs text-slate-500">
                    {p.sku} · {qtyFmt(depotId ? p.stock?.[depotId] : p.qty)} {p.unit}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
